import { LocaleKey } from 'helpers/languages/translations';
import { TIcon } from 'shared/icons';

type TCardParam = {
    [key: string]: { title: LocaleKey; link?: any; multiple?: boolean; path?: string };
};

type TSection = {
    icon: TIcon;
    title: LocaleKey;
    order: number;
};

// TODO: change link to function so that we will call it when we click the card
export const statsCards: { cdm_clientsproduct: TCardParam; cdm_keywords: TCardParam; cdm_usermanager: TCardParam } = {
    cdm_clientsproduct: {
        nbProducts: { title: 'kpi.products.nbProducts', link: false },
        nbNoName: { title: 'kpi.products.nbNoName', link: true, path: '/product-management' },
        nbWithAlias: { title: 'kpi.products.nbWithAlias', link: true, path: '/product-management' },
        noNameLanguages: {
            multiple: true,
            title: 'kpi.products.noNameLanguages',
            link: true,
            path: '/product-management',
        },
    },
    cdm_keywords: {
        internationals: { title: 'kpi.keywords.internationals', link: true, path: '/keywords-management/search' },
        nbBanner: { title: 'kpi.keywords.nbBanner' },
        nbSearch: { title: 'kpi.keywords.nbSearch' },
        noType: { title: 'kpi.keywords.noType', link: true, path: '/keywords-management/search' },
        types: { title: 'kpi.keywords.types' },
        languages: { multiple: true, title: 'kpi.keywords.languages', link: true, path: '/keywords-management/search' },
    },
    cdm_usermanager: {
        companyGroups: { title: 'kpi.users.companyGroups' },
        nbUsers: { title: 'kpi.users.nbUsers' },
    },
};

export const statsSections: { cdm_clientsproduct: TSection; cdm_keywords: TSection; cdm_usermanager: TSection } = {
    cdm_clientsproduct: { icon: 'productBis', title: 'kpi.products', order: 1 },
    cdm_keywords: { icon: 'keywords', title: 'kpi.keywords', order: 2 },
    cdm_usermanager: { icon: 'user', title: 'kpi.users', order: 3 },
};
